const isLocalhost = ["localhost", "127.0.0.1"].includes(
  window.location.hostname
);
const localhostApiUrl =
  window.location.origin ||
  `http://127.0.0.1:${process.env.VITE_PORT || process.env.API_PORT || 3000}`;
const productionApiUrls: Record<string, string> = {
  "staging.zuv.app": "https://zuv-api-staging.rough-base-4af9.workers.dev/",
  "zuv.app": "https://zuv-api-production.rough-base-4af9.workers.dev",
};
const apiUrl = isLocalhost
  ? localhostApiUrl
  : productionApiUrls[window.location.hostname];

if (!apiUrl) {
  throw new Error(`Unsupported hostname: ${window.location.hostname}`);
}

export const config = {
  app: { name: "Zuv" },
  localStorageKeys: {
    token: `zuv:authToken`,
  },
  apiUrl,
};
